@if(displayFormat() === 'fixed' || (displayFormat() === 'collapsible' && isCollapsibleChatbotOpen())) {
  <mat-sidenav-container
    class="chatbot-main-container"
    [class.collapsible-chatbot-main-container]="displayFormat() === 'collapsible'"
    aria-label="Chatbot interface"
  >

    <mat-sidenav-content>
      <mat-card
        [ngClass]="displayFormat() === 'collapsible' ? 'chatbot-container-collapsible' : 'chatbot-container-fixed'"
        class="chatbot-container"
      >
        <!-- Chatbot header with controls -->
        <mat-card-header>
          <app-chatbot-header [(isCollapsibleChatbotOpen)]="isCollapsibleChatbotOpen"
          />
        </mat-card-header>

        <!-- Messages display area -->
        <mat-card-content
          class="chatbot-messages-container"
          #messageContainer
          role="log"
          aria-live="polite"
          aria-label="Chat messages"
        >
          @for (message of messages(); track $index) {
            <div class="message-group w-fit {{ message.type }}">
              <article
                class="chatbot-message-wrapper {{ message.type }}"
                [attr.aria-label]="message.type === 'user' ? 'Your message' : 'AI response'"
              >
                <!-- Avatar icon -->
                
                  <div class="message-avatar">
                    @if(message.type === 'bot' || message.type === 'loading') {
                      
                      <div class="avatar-icon bot-icon"><img src="assets/images/artificial-intelligence-filled.svg" alt="AI assistant avatar" class="button-icon !rounded-full"></div>
                    } @else {
                      <dsr-icon class="avatar-icon user-icon" name="user" aria-label="User avatar"></dsr-icon>
                    }
                  </div>
                
                
                <!-- Message bubble -->
                <div class="chatbot-message dsr-typescale-body-small {{ message.type }}">
                  @if(message.type === 'loading') {
                    <span class="loading-indicator"><!-- Loading animation handled by CSS --></span>
                  } @else {
                    <div [innerHTML]="formatMessage(message.text!, message.type === 'bot')">
                    </div>
                  }
                </div>
              </article>
              <!-- Timestamp below message -->
              @if(message.timestamp && message.type !== 'loading') {
                <div class="w-full flex message-timestamp"><span class=" dsr-typescale-body-small">{{ formatTime(message.timestamp) }}</span></div>
              }
              
            </div>
          }
        </mat-card-content>

        <!-- Prepared prompts -->
        @if(messages().length <= 1) {
          <div class="prepared-prompts-container">
            @for (prompt of preparedPrompts(); track $index) {
              <button class="prompt-button dsr-typescale-body-small" (click)="sendPreparedPrompt(prompt)">
                {{ prompt }}
              </button>
            }
          </div>
        }

        <!-- Chat input area -->
        <mat-card-footer>
          <app-chatbot-chat-input
            (enterPressed)="onEnterPressed($event)"
            (submitBtnClicked)="sendUserMessage()"
            [message]="message"
            [canSendMessage]="canSendMessage() && !limitReached"
            [limitReached]="limitReached"
            [remainingMessages]="remainingMessages"
          />
          <div class="disclaimer dsr-typescale-body-small">
            {{ 'CHATBOT_DISCLAIMER' | translate }}
          </div>
        </mat-card-footer>
      </mat-card>
    </mat-sidenav-content>
  </mat-sidenav-container>
}